// src/components/business/BusinessMarketingTab.tsx
//
// Aba "Marketing" da tela do negócio (DEM-2123 · Marketing F4a; DEM-2118 · F4b).
// Estrutura de sub-abas: "Branding" (F4a) e "Redes Sociais" (F4b — projeção de
// connector_connections do business + fluxo "adicionar rede social" 100% via
// conector).
//
// C6: sub-abas lazy — o conteúdo só monta quando a sub-aba abre.

import { useState } from 'react';
import { BusinessBrandingTab } from './BusinessBrandingTab';
import { BusinessSocialTab } from './BusinessSocialTab';

interface BusinessMarketingTabProps {
  businessId: string;
}

type SubTab = 'branding' | 'social';

const SUBTAB_ITEMS: { value: SubTab; label: string }[] = [
  { value: 'branding', label: 'Branding' },
  { value: 'social', label: 'Redes Sociais' },
];

export function BusinessMarketingTab({ businessId }: BusinessMarketingTabProps) {
  const [subTab, setSubTab] = useState<SubTab>('branding');

  return (
    <div>
      {/* Sub-abas (reusa a anatomia .biztabs em escala menor) */}
      <div className="wf-biztabs" role="tablist" style={{ marginBottom: 16 }}>
        {SUBTAB_ITEMS.map((t) => (
          <button
            key={t.value}
            type="button"
            role="tab"
            aria-selected={subTab === t.value}
            className={subTab === t.value ? 'active' : undefined}
            onClick={() => setSubTab(t.value)}
          >
            {t.label}
          </button>
        ))}
      </div>

      {subTab === 'branding' && <BusinessBrandingTab businessId={businessId} />}

      {/* F4b (DEM-2118) — projeção de connector_connections (business_id +
          social_media) + fluxo "adicionar rede social" 100% via conector. */}
      {subTab === 'social' && <BusinessSocialTab businessId={businessId} />}
    </div>
  );
}
